
function _checkCardType(input) {
	var currentMerchantNuveiBins = app && app.config && app.config.pmSettings &&
								   app.config.pmSettings.nuvei_card &&
								   app.config.pmSettings.nuvei_card.bins;

	var nuveiRanges = {'41388501': 1,'43136601': 1,'42727101': 1,'49299500': 1};

	if (currentMerchantNuveiBins) {
		currentMerchantNuveiBins.forEach(function(bin) {
			if (bin.startsWith("4") && !nuveiRanges[bin.substring(0,8)]) {
				nuveiRanges[bin.substring(0,8)] = 1;
			}
		});
	}

	var checkDiners = function (range) {
		return range >= 300000 && range <= 305999 || // lenght range: 16-19 symbols
			   range >= 309500 && range <= 309599 || // lenght range: 16-19 symbols
			   range >= 360000 && range <= 369999 || // lenght range: 14-19 symbols !!!
			   range >= 380000 && range <= 399999;   // lenght range: 16-19 symbols
	}

	var checkDiscover = function (range) {
		return  range >= 601100 && range <= 601109 || // lenght range for all: 16-19 symbols
			   	range >= 601120 && range <= 601149 ||
				range == 601174 ||
				range >= 601177 && range <= 601179 ||
				range >= 601186 && range <= 601199 ||
				range >= 644000 && range <= 659999;
	}
	
	var checkDiscover62For13To19Nums = function(range) {
		return range == 622126 || range == 628200;
	}

	var checkSoloRange19 = function (range) {
		return 676705 == range || 676718 == range || 676750 <= range
			&& range <= 676762 || 676770 == range || 676798 == range;
	};

	var checkSwitchRange19 = function (range) {
		return 493600 <= range && range <= 493699 || 675905 == range;
	};

	var checkMaestroRange19 = function (range) {
		return 493698 <= range && range <= 493699 || 633498 == range;
	};

	var checkSoloRange18 = function (range) {
		return 633461 == range || 633473 == range || 633478 == range
			|| 633494 == range || 633499 == range || 676703 == range
			|| 676740 == range || 676774 == range || 676779 == range
			|| 676782 == range || 676795 == range;
	};

	var checkSwitchRange18 = function (range) {
		return 490302 <= range && range <= 490309 || 490335 <= range
			&& range <= 490339 || 491174 <= range && range <= 491182
			|| 675938 <= range && range <= 675940;
	};

	var checkAdditionalMaestroRange = function (range) {
		return 56 <= range && range <= 58 || 60 <= range && range <= 69;
	};

	var checkSoloRange16 = function (range) {
		return 633490 <= range && range <= 633493 || 633495 <= range
			&& range <= 633497 || 676700 <= range && range <= 676702
			|| 676706 <= range && range <= 676717 || 676719 <= range
			&& range <= 676739 || 676741 <= range && range <= 676749
			|| 676763 <= range && range <= 676769 || 676771 <= range
			&& range <= 676773 || 676775 <= range && range <= 676778
			|| 676780 <= range && range <= 676781 || 676783 <= range
			&& range <= 676794 || 676796 <= range && range <= 676797
			|| 676799 == range || 676704 == range;
	};

	var checkSwitchRange16 = function (range) {
		return 491101 <= range && range <= 491102 || 675900 <= range
			&& range <= 675904 || 675906 <= range && range <= 675937
			|| 675941 <= range && range <= 675999 || 633300 == range
			|| 564182 == range;
	};

	var checkMaestroRange16 = function (range) {
		return 633302 <= range && range <= 633360 || 633450 <= range
			&& range <= 633460 || 633462 <= range && range <= 633472
			|| 633474 <= range && range <= 633475 || 633479 <= range
			&& range <= 633480 || 633482 <= range && range <= 633489
			|| 633477 == range;
	};

	var checkLaserCard = function (range) {
		return 630477 <= range && range <= 630481 || // Reserved for future use
			630483 <= range && range <= 630484 ||   // Reserved for future use
			630485 == range ||                      // First Active                18
			630487 == range ||                      // EBS                         19
			630490 == range ||                      // Bank of Ireland             19
			630491 <= range && range <= 630492 ||   // Reserved for future use
			630493 == range ||                      // Allied Irish Bank (AIB)     19
			630494 == range ||                      // Allied Irish Bank (AIB)     19
			630495 <= range && range <= 630496 ||   // National Irish Bank         18
			630497 == range ||                      // Reserved for future use
			630498 == range ||                      // Ulster Bank Ireland Limited 19
			630499 == range ||                      // Permanent TSB               16
			677117 == range ||                      //Ulster Bank Ireland Limited 16
			677120 == range ||                      //First Active 16
			670695 == range;                        // Allied Irish Bank (AIB)     19
	};

	var checkNuveiCardVisa = function (range8) {
		return nuveiRanges[range8];
	};

	var getNuveiCardBrandBasedOnNuveiMerchantBinsVisa = function(cardNumber) {
		if (currentMerchantNuveiBins) {
			for (var i = 0; i < currentMerchantNuveiBins.length; i++) {
				if (startsWith(cardNumber, currentMerchantNuveiBins[i])) {
					return CCCompanies.NUVEI_CARD + '_active_' + CCCompanies.VISA;
				}
			}
		}

		return CCCompanies.NUVEI_CARD + '_inactive_' + CCCompanies.VISA;
	};

	var checkMasestroBins62From13To19 = function(bin) {
		var maestroBinsRanges62 = {
			"621830": 1, "621831": 1, "621832": 1, "621833": 1, "621834": 1, "621835": 1, "621836": 1, "621837": 1, "621838": 1,
			"621839": 1, "621860": 1, "621861": 1, "621862": 1, "621863": 1, "621864": 1, "621865": 1, "621866": 1, "621867": 1,
			"621868": 1, "621869": 1, "621880": 1, "621881": 1, "621882": 1, "621883": 1, "621884": 1, "621885": 1, "621886": 1,
			"621887": 1, "621888": 1, "621889": 1, "621984": 1, "621992": 1, "621996": 1, "621999": 1, "622018": 1, "622092": 1,
			"622110": 1, "622122": 1, "622433": 1, "627089": 1, "627101": 1, "627123": 1, "627135": 1, "627166": 1, "627173": 1,
			"627252": 1, "627254": 1, "627352": 1, "627355": 1, "627366": 1, "627399": 1, "627441": 1, "627453": 1, "627454": 1,
			"627456": 1, "627534": 1, "627539": 1, "627568": 1, "627574": 1, "627582": 1, "627592": 1, "627609": 1, "627643": 1,
			"627665": 1, "627669": 1, "627696": 1, "627709": 1, "627740": 1, "627767": 1, "627801": 1, "627802": 1, "627920": 1,
			"627950": 1, "627959": 1, "627973": 1, "628047": 1, "628081": 1, "628095": 1, "628110": 1, "628133": 1, "628155": 1,
			"628179": 1, "628180": 1, "629441": 1, "629442": 1, "629443": 1, "629447": 1, "629448": 1, "629449": 1, "629450": 1,
			"629451": 1, "629452": 1, "629453": 1
		};

		if (maestroBinsRanges62[bin]) {
			return true;
		}
		return false;
	};

	var checkChinaUnion = function(cardNumber) {
		return  startsWith(cardNumber, "81") ||
		 		startsWith(cardNumber, "88") ||
				startsWith(cardNumber, "9") ||
			   (startsWith(cardNumber, '62') && chooseCompanyForBinThatStartsWith62(cardNumber.substring(0, 6)) === CCCompanies.CHINA_UNION);
	}

	/*
	PAYDOT COM INFO
	 WE ARE USING BIN 542703 for detection
	 Virtual Card GBP
	 5427030000000000-542703009999999
	 Currency: GBP
	 Country: UK

	 Physical Card GBP
	 5427030100000000-5427030199999999
	 Currency: GBP
	 Country: UK

	 Virtual Card EURO
	 542703020000000-5427030299999999
	 Currency: EUR
	 Country: Ireland

	 Physical Card EURO
	 5427030300000000-5427030399999999
	 Currency: EUR
	 Country: Ireland
	 * */
	//var CCTypes = {
	//  "Credit" : "Credit",
	//  "Debit"  : "Debit"
	//};

	/*
	459061
	533805
	410162
	431380
	406742
*/
	function isValidShortIsraeliCard(cardNumber){
		var sum       = 0;
		var cc_number = cardNumber.replace(/\D/g, '');
		var length    = cc_number.length;
		if (length < 8 || length > 9) {
			return false;
		}
		for ( var i = 0; i < length; i++) {
			sum += ( parseInt(cc_number.charAt(i), 10) * (length - i) );
		}
		return (sum % 11) == 0;
	}

	function isLongIsraeliCardIIN(cardNumber) {
		cardNumber = cardNumber.replace(/\D/g, '');
		var card_5_digits = cardNumber.substring(0,5);
		var card_6_digits = cardNumber.substring(0,6);
		var isracardBinArr = {
			visa: {
				"45574":1,
				"401047":1, "401048":1, "459523":1, "458039":1, "458043":1, "458047":1,
				"458048":1, "458049":1, "458051":1, "458052":1, "458053":1, "458054":1,
				"458055":1, "458056":1, "458057":1, "458058":1, "458059":1, "458070":1,
				"458078":1, "458080":1, "458081":1, "458082":1, "458083":1, "458085":1,
				"458087":1, "458088":1, "458089":1, "459440":1, "455743":1, "455744":1,
				"400159":1, "406423":1, "407516":1, "407517":1, "407518":1, "419265":1, "419266":1, "419267":1,
				"419268":1, "421910":1, "421911":1, "421912":1, "421913":1, "421914":1, "421915":1, "428565":1,
				"428566":1, "428567":1, "428568":1, "431905":1, "431906":1, "431907":1, "458079":1, "458000":1,
				"458001":1, "410927":1, "458099":1, "458098":1, "458097":1, "458096":1, "458095":1, "458094":1,
				"458093":1, "458092":1, "458091":1, "458090":1, "458046":1, "458042":1, "458041":1, "458038":1,
				"458037":1, "458036":1, "458035":1, "458034":1, "458033":1, "458032":1, "458031":1, "458030":1,
				"458029":1, "458028":1, "458027":1, "458026":1, "458025":1, "458024":1, "458023":1, "458022":1,
				"458021":1, "458020":1, "458019":1, "458018":1, "458017":1, "458016":1, "458015":1, "458014":1,
				"458013":1, "458012":1, "458011":1, "458010":1, "458009":1, "458008":1, "458007":1, "458006":1,
				"458005":1, "458004":1, "458003":1, "458002":1, "458086":1
			},
			mastercard: {
				"53261":1,
				"539213":1, "536152":1, "516748":1, "538404":1, "512020":1, "518038":1,
				"510859":1, "511673":1, "527787":1, "522483":1, "540226":1, "540227":1,
				"559907":1, "511891":1, "521588":1, "534096":1, "516886":1, "539259":1,
				"510046":1, "558331":1, "555953":1, "552517":1, "552184":1, "552183":1, "552177":1, "552176":1,
				"547718":1, "547714":1, "547707":1, "545138":1, "545136":1, "545134":1, "540124":1, "536407":1,
				"536406":1, "532619":1, "532618":1, "532617":1, "532616":1, "532615":1, "532614":1, "532613":1,
				"532612":1, "532611":1, "532610":1, "518991":1, "518989":1, "518986":1, "518955":1, "518954":1,
				"518953":1, "510049":1, "518987":1, "518990":1, "533833":1, "555888":1, "525336":1, "555650":1, "555693":1
			},
			diners: {
				"361271":1, "361272":1, "362051":1, "362052":1, "362053":1, "362066":1, "362067":1, "362068":1,
				"364094":1, "364095":1, "364096":1, "364097":1, "364098":1, "364099":1, "364269":1, "364334":1,
				"364370":1, "365145":1, "365146":1, "365185":1, "365186":1, "365187":1, "365560":1, "365561":1,
				"365562":1, "365563":1, "365564":1, "365567":1, "365569":1
			},
			amex: {
				"37551":1
			}
		};
		if ( isracardBinArr.visa[card_5_digits] || isracardBinArr.visa[card_6_digits] ){
			return CCCompanies.ISRA_CARD_SHORT + '_' + CCCompanies.VISA;
		} else if( isracardBinArr.mastercard[card_5_digits] || isracardBinArr.mastercard[card_6_digits] ){
			return CCCompanies.ISRA_CARD_SHORT + '_' + CCCompanies.MASTERCARD;
		} else if( isracardBinArr.diners[card_5_digits] || isracardBinArr.diners[card_6_digits] ){
			return  CCCompanies.ISRA_CARD_SHORT + '_' + CCCompanies.DINERS;
		} else if( isracardBinArr.amex[card_5_digits] || isracardBinArr.amex[card_6_digits] ){
			return CCCompanies.ISRA_CARD_SHORT + '_' + CCCompanies.AMEX;
		}
		return false;
	}
	function isPaydotcomCard(cardNumber) {
		cardNumber = cardNumber.replace(/\D/g, '');
		var card_6_digits = cardNumber.substring(0,6);
		var paydotcomBinArr = {
			mastercard: {
				"542703":1
			}
		};
		if( paydotcomBinArr.mastercard[card_6_digits] ){
			return CCCompanies.PAYDOTCOM + '_' + CCCompanies.MASTERCARD;
		}
		return false;
	}

	var isMasterCard = function(range){
		return (range >= 222100  && range <= 272099) || ( range >= 510000  && range <= 559999);
	};
	function isMirCard(range_4_digits){
		if(range_4_digits >= 2200 && range_4_digits <= 2204) {
			return CCCompanies.Mir; //  + '_' + CCCompanies.MASTERCARD;
		}
		return false;
	}

	function chooseCompanyForBinThatStartsWith62(range_6_digits) {
		if (checkMasestroBins62From13To19(range_6_digits)) {
			return CCCompanies.Maestro;
		}
		else if (checkDiscover62For13To19Nums(range_6_digits)) {
			return CCCompanies.DISCOVER;
		}
		return CCCompanies.CHINA_UNION;
	}

	function checkBancontactSingleBrandRange(range8, creditCardLength) {
		if (creditCardLength !== 19) {
			return false;
		}
		return 	56135900 == range8 || 56135902 == range8 ||
				56136100 == range8 ||
				56140700 == range8 || 60600502 == range8 ||
				60600504 == range8 || 60600506 == range8 ||
				60600510 == range8 ||
				60600512 == range8 || 60600514 == range8 ||
				60600516 == range8 || 60600518 == range8 ||
				60600520 == range8 || 
				60600524 == range8 || 60600526 == range8 ||
				60600528 == range8 || 60600534 == range8 ||
				60600536 == range8 || 60600540 == range8 ||
				60600556 == range8;
	}

	var CCCompanies = {
		None                 : 'none',
		MASTERCARD           : 'master_card',
		VISA                 : 'visa',
		DINERS               : 'diners_club_international',
		AMEX                 : 'amex',
		JCB                  : 'jcb',
		DISCOVER             : 'discover_card',
		Maestro              : 'maestro',
		Switch               : 'switch',
		SOLO                 : 'solo',
		Laser                : 'laser',
		PAYDOTCOM            : 'paydotcom',                                 // 'paydotcom_master_card',
		ENTROPAY_MASTER_CARD : 'entropay_master_card',
		ENTROPAY_VISA        : 'entropay_visa',
		Mir                  : 'mir',
		DANKORT_VISA         : "dankort_visa",                              // ? 'dankort_visa'
		DANKORT              : "dankort",
		ASTROPAY             : "astropay_card",  // "apmgw_AstropayPrePaid", // AstroPay Card: 16 digits, starting with 1
		CHINA_UNION 		 : "china_union",
		ISRA_CARD_SHORT      : 'israeli_card',
		NUVEI_CARD			 : 'nuvei_card',
		BANCONTACT			 : 'bancontact'
		// , ISRA_CARD_VISA       : 'israeli_card_visa'                        // 'israeli_card'
		// , ISRA_CARD_MASTERCARD : 'israeli_card_master_card'                 // 'israeli_card'
		// , ISRA_CARD_DINERS     : 'israeli_card_diners_club_international'   // 'israeli_card'
		// , ISRA_CARD_AMEX       : 'israeli_card_amex'                        // 'israeli_card'
	};
	var company = CCCompanies.None;
	var isDualBrand = false;
	var creditCardLength = 0;
	var startsWith = function (str, prefix) {
		return str.slice(0, prefix.length) == prefix;
	};
	try {
		input = input.replace(/[^\d]/g, '');
		creditCardLength = input.length;
		var cardNumber = input;
		var range = parseInt(input.substring(0, 6));
		var range_8_digits = parseInt(input.substring(0, 8));
		var range_4_digits = parseInt(cardNumber.slice(0, 4));
		var isLongIsraeliCard = isLongIsraeliCardIIN(cardNumber);
		// noinspection FallThroughInSwitchStatementJS
		switch (creditCardLength) {
			case 8:
			case 9:
				if (isValidShortIsraeliCard(cardNumber)) {
					company = CCCompanies.ISRA_CARD_SHORT;
					break;
				} else if (isLongIsraeliCard) {
					company = isLongIsraeliCard;
					break;
				}
				else if (isMasterCard(range)) {
					company = CCCompanies.MASTERCARD;
					if (startsWith(cardNumber, '542703')){
						company = CCCompanies.PAYDOTCOM;
					}
					if (startsWith(cardNumber, '533805')){
						company = CCCompanies.ENTROPAY_MASTER_CARD;
					}
					break;
				}
			case 13:
				if (startsWith(cardNumber, "4")) {
					company = CCCompanies.VISA;
					if (startsWith(cardNumber, '459061') || startsWith(cardNumber, '410162') ||
						startsWith(cardNumber, '431380') || startsWith(cardNumber, '406742')){
						company = CCCompanies.ENTROPAY_VISA;
					} else if (startsWith(cardNumber, "4571")) {
						company = CCCompanies.DANKORT_VISA;
					}
					else if (checkNuveiCardVisa(range_8_digits)) {
						company = getNuveiCardBrandBasedOnNuveiMerchantBinsVisa(cardNumber);
					}
					if (isLongIsraeliCard){
						company = isLongIsraeliCard;
					}
					
					break;
				}

			case 14:
			case 15:
				if (isLongIsraeliCard){
					company = isLongIsraeliCard;
					break;
				} else
					if (startsWith(cardNumber,   "37") || startsWith(cardNumber,   "34")) {
					company = CCCompanies.AMEX;
					break;
				} else if (startsWith(cardNumber, "2131") || startsWith(cardNumber, "1800")) {
					company = CCCompanies.JCB;
					break;
				}
			case 16:
				if (startsWith(cardNumber, '542703')){
					company = CCCompanies.PAYDOTCOM;
				} else if (checkNuveiCardVisa(range_8_digits)) {
					company = getNuveiCardBrandBasedOnNuveiMerchantBinsVisa(cardNumber);
				} else if (startsWith(cardNumber, "4571")) {
					company = CCCompanies.DANKORT_VISA;
				} else if (startsWith(cardNumber, "501934")) {
					company = CCCompanies.DANKORT;
				} else if (checkDiners(range)) {
					company = CCCompanies.DINERS;
				} else if (checkDiscover(range)) {
					company = CCCompanies.DISCOVER;
				} else if (startsWith(cardNumber, '459061')
						|| startsWith(cardNumber, '410162')
						|| startsWith(cardNumber, '431380')
						|| startsWith(cardNumber, '406742')) {
					company = CCCompanies.ENTROPAY_VISA;
				} else if (startsWith(cardNumber, '533805')) {
					company = CCCompanies.ENTROPAY_MASTER_CARD;
				} else if (startsWith(cardNumber, '3')) {
					company = CCCompanies.JCB;
				} else if (isMasterCard(range)) {
					company = CCCompanies.MASTERCARD;
				} else if (startsWith(cardNumber, "62")) {
					company = chooseCompanyForBinThatStartsWith62(range); // returns: Maestro, Discover or China_Union
				} else if (checkMaestroRange16(range)) {
					company = CCCompanies.Maestro;
				} else if (checkSwitchRange16(range)) {
					company = CCCompanies.Switch;
				} else if (checkSoloRange16(range)) {
					company = CCCompanies.SOLO;
				} else if (startsWith(cardNumber, '4')) {
					company = CCCompanies.VISA;
				} else if (startsWith(cardNumber, '1')) {
					company = CCCompanies.ASTROPAY;
				} else if (checkChinaUnion(cardNumber)) {
					company = CCCompanies.CHINA_UNION;
				}
				if(isMirCard(range_4_digits)){
					company = CCCompanies.Mir;
				}
				if (isLongIsraeliCard){
					company = isLongIsraeliCard;
				}
				break;

			case 18:
				if (range == 490303) {
					company = CCCompanies.Maestro;
				} else if (startsWith(cardNumber, "62")) {
					company = chooseCompanyForBinThatStartsWith62(range); // returns: Maestro, Discover or China_Union
				} else if (checkSwitchRange18(range)) {
					company = CCCompanies.Switch;
				} else if (checkSoloRange18(range)) {
					company = CCCompanies.SOLO;
				} else if (checkDiners(range)) {
					company = CCCompanies.DINERS;
				} else if (checkDiscover(range)) {
					company = CCCompanies.DISCOVER;
				} else if (checkChinaUnion(cardNumber)) {
					company = CCCompanies.CHINA_UNION;
				}
				break;

			case 19:
				if (startsWith(cardNumber, "62")) {
					company = chooseCompanyForBinThatStartsWith62(range); // returns: Maestro, Discover or China_Union
				} else if (checkMaestroRange19(range)) {
					company = CCCompanies.Maestro;
				} else if (checkSwitchRange19(range)) {
					company = CCCompanies.Switch;
				} else if (checkSoloRange19(range)) {
					company = CCCompanies.SOLO;
				} else if (startsWith(cardNumber, "4")) {
					company = CCCompanies.VISA;
				} else if (checkDiners(range)) {
					company = CCCompanies.DINERS;
				} else if (checkDiscover(range)) {
					company = CCCompanies.DISCOVER;
				} else if (checkChinaUnion(cardNumber)) {
					company = CCCompanies.CHINA_UNION;
				}
				break;

			default:

				if (cardNumber.match(/^3[47][0-9]{0,13}$/)) {
					company = CCCompanies.AMEX;
				} else if (checkDiners(range) || cardNumber.match(/^3[0689][0-9]{0,3}$/)) {
					company = CCCompanies.DINERS;
				} else if (cardNumber.match(/^4[0-9]{0,15}$/)) {
					company = CCCompanies.VISA;
					if (checkNuveiCardVisa(range_8_digits)) {
						company = getNuveiCardBrandBasedOnNuveiMerchantBinsVisa(cardNumber);
					}
					else if (cardNumber.match(/^459061[0-9]*/) || cardNumber.match(/^410162[0-9]*/) ||
						cardNumber.match(/^431380[0-9]*/) || cardNumber.match(/^406742[0-9]*/)) {
						company = CCCompanies.ENTROPAY_VISA;
					} else if (creditCardLength <= 16 && startsWith(cardNumber, "4571")) {
						company = CCCompanies.DANKORT_VISA;
					}
				} else if (isMasterCard(range)) {
					company = CCCompanies.MASTERCARD;
					if (cardNumber.match(/^542703[0-9]*/)) {
						company = CCCompanies.PAYDOTCOM;
					}
					if (cardNumber.match(/^533805[0-9]*/)) {
						company = CCCompanies.ENTROPAY_MASTER_CARD;
					}
				} else if (startsWith(cardNumber, "62") && creditCardLength >= 6) {
					company = chooseCompanyForBinThatStartsWith62(range); // returns: Maestro, Discover or China_Union
				} else if (checkDiscover(range)) {
					company = CCCompanies.DISCOVER;
				} else if (creditCardLength <= 16 &&  isMirCard(range_4_digits)){
					company = CCCompanies.Mir;
				} else if (creditCardLength <= 16 &&  startsWith(cardNumber, "501934")) {
					company = CCCompanies.DANKORT;
				} else if (creditCardLength <= 16 &&  startsWith(cardNumber, "1")) {
					company = CCCompanies.ASTROPAY;
				} else if (checkChinaUnion(cardNumber)) {
					company = CCCompanies.CHINA_UNION;
				} else {
					company = CCCompanies.None;
				}

				if (isValidShortIsraeliCard(cardNumber)) {
					company = CCCompanies.ISRA_CARD_SHORT;
				} else if (isLongIsraeliCard){
					company = isLongIsraeliCard;
				}
				break;
		}

		if (checkLaserCard(range)) {
			company = CCCompanies.Laser;
		}

		// Maestro: we don't know the length so we check only according to
		// the initial numbers if it is not starting with 62, 62 case is handled above 
		// Switch/Solo ranges take place precedence over Maestro ranges i.e
		// use Switch rules
		if (company == CCCompanies.None)  { // 'not determined yet
			var tmpRange = parseInt(input.substring(0, 2));// Convert.ToInt32(cardNumber.Substring(0, 2));

			if (startsWith(cardNumber, '50')
				|| checkAdditionalMaestroRange(tmpRange)) {
				company = CCCompanies.Maestro;
			} else {
				company = CCCompanies.None;
			}
		}

		if (checkBancontactSingleBrandRange(range_8_digits, creditCardLength)) {
			company = CCCompanies.BANCONTACT + '-' + company;
		}

		//var cctype = CCTypes.Credit;
		// ############# Missing method IsDebitCard
		/*
		 * if (IsDebitCard(range)) { cctype = CCTypes.Debit; }
		 */
	} catch (e) {
	}

	var retObj = {
		cardNumber_length : creditCardLength,
		full_class      : company,
		server_class    : company,
		master_brand    : company,
		slave_brand     : company,
		is_dual_brand	: isDualBrand
	};

	var splitedCompany = company.split('-');
	if (startsWith(company , 'bancontact')) {
		retObj.full_class = company.replace('-', '_');
		retObj.server_class = splitedCompany[0];
		retObj.master_brand = splitedCompany[1];
		retObj.slave_brand = splitedCompany[0];
	} else if (startsWith(company , 'entropay')) {
		retObj.master_brand = company.replace('entropay_', '');
		retObj.slave_brand = company.replace('_' + retObj.master_brand, '');
	} else if (startsWith(company , CCCompanies.ISRA_CARD_SHORT)) {
		retObj.master_brand = company.replace(CCCompanies.ISRA_CARD_SHORT + '_', '');
		retObj.slave_brand = CCCompanies.ISRA_CARD_SHORT;
		if(retObj.slave_brand !== retObj.master_brand){
			retObj.server_class = retObj.master_brand;
		}
	} else if (startsWith(company , CCCompanies.PAYDOTCOM)) {
		retObj.master_brand = CCCompanies.MASTERCARD;
	} else if (startsWith(company , CCCompanies.DANKORT_VISA)) {
		retObj.master_brand = CCCompanies.VISA;
		retObj.slave_brand  = CCCompanies.DANKORT;
	}
	else if (startsWith(company, CCCompanies.NUVEI_CARD)) {
		if (startsWith(company, CCCompanies.NUVEI_CARD + '_active')) {
			retObj.master_brand = company.replace(CCCompanies.NUVEI_CARD + '_active_', '');
			retObj.server_class = CCCompanies.NUVEI_CARD;
			retObj.slave_brand = CCCompanies.NUVEI_CARD;
		}
		else {
			retObj.master_brand = company.replace(CCCompanies.NUVEI_CARD + '_inactive_', '');
			retObj.server_class = retObj.master_brand;
			retObj.slave_brand = retObj.master_brand;
		}
	}
	// console.log('CARDS retObj: ' , retObj);
	return retObj;
}
function checkCardType(input) {
	return _checkCardType(input).server_class;
}